<template>
  <v-layout wrap class="container px-2 py-0">
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('mechanic.acceptFull') }}</h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <mechanic-auto-form />
  </v-layout>
</template>

<script>
import store from '@/store';
import MechanicAutoForm from '@/components/mechanic/MechanicAutoForm.vue';
// import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  name: 'MechanicPage',
  components: { MechanicAutoForm },
  beforeRouteEnter(to, from, next) {
    store.commit('global/setRole', null, { root: true });
    next();
  },
};
</script>

<style lang="scss" scoped></style>
